import { SET_WITHDRAW_DATA } from './../../actions/withdraw/index';

const initialState = {
    result: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_WITHDRAW_DATA:
            return { ...state, result: action.payload.items };
        default:
            return state;
    }
}